"use strict";

import sessionStore from "./../store/session";
import serviceStore from "./../store/services";

export default {
	getUser,
	getUserId,
	getUnitAssignment,
	getContacts
};

export {getUnitAssignment as getUnitAssignment};
export {getUser as getUser};
export {getUserId as getUserId};
export {getContacts as getContacts};

function getUser() {
	const session = sessionStore.get();
	if (!session) return null;
	return session.user;
}

function getUserId() {
	const user = getUser();
	if (!user) return null;
	return user._id;
}

function getUnitAssignment() {
	
	const session = sessionStore.get();
	
	if (!session || !session.user)
		return null;
	
	const dashboardServices = session.user.services.filter(serviceSet =>
		serviceSet.service == serviceStore.get("Dashboard")._id
	);

	if (dashboardServices.length === 0)
		return serviceStore.get("Dashboard").default.units;
	else
		return dashboardServices[0].value.units;
}

function getContacts() {
	
	const session = sessionStore.get();
	
	if (!session || !session.user)
		return [];
	
	return session.user.contacts || [];
}


// WEBPACK FOOTER //
// ./src/utils/user.js